/**
 * Efast 工作台 - 统一认证模块
 * 编码: UTF-8
 */

var AUTH_SERVER = window.location.origin;

const Auth = {
  getToken() {
    return sessionStorage.getItem('efast_token') || localStorage.getItem('efast_token_persist');
  },

  getUser() {
    try {
      const raw = sessionStorage.getItem('efast_user') || localStorage.getItem('efast_user_persist');
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  },

  setSession(token, user) {
    sessionStorage.setItem('efast_token', token);
    sessionStorage.setItem('efast_user', JSON.stringify(user));
  },

  clearSession() {
    sessionStorage.removeItem('efast_token');
    sessionStorage.removeItem('efast_user');
  },

  isLoggedIn() {
    return !!(this.getToken() || localStorage.getItem('efast_token_persist'));
  },

  getRole() {
    const user = this.getUser();
    return user ? user.role : null;
  },

  getDisplayName() {
    const user = this.getUser();
    return user ? user.displayName : null;
  },

  async verifyToken() {
    const token = this.getToken();
    if (!token) return false;

    try {
      const res = await fetch(`${AUTH_SERVER}/api/me`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!res.ok) {
        this.clearSession();
        return false;
      }
      const data = await res.json();
      this.setSession(token, data.user);
      return true;
    } catch (e) {
      return !!this.getUser();
    }
  },

  requireAuth() {
    if (!this.isLoggedIn()) {
      window.location.href = '/login.html';
      return false;
    }
    if (!sessionStorage.getItem('efast_token')) {
      var persistToken = localStorage.getItem('efast_token_persist');
      var persistUser = localStorage.getItem('efast_user_persist');
      if (persistToken) {
        this.setSession(persistToken, persistUser ? JSON.parse(persistUser) : null);
      }
    }
    this.verifyToken();
    return true;
  },

  logout() {
    this.clearSession();
    localStorage.removeItem('efast_token_persist');
    localStorage.removeItem('efast_user_persist');
    window.location.href = '/login.html';
  },

  canSeeAllData() {
    const role = this.getRole();
    return role === 'boss' || role === 'manager' || role === 'supervisor';
  },

  filterByRole(items, field) {
    if (this.canSeeAllData()) return items;
    const displayName = this.getDisplayName();
    if (!displayName) return [];
    return items.filter(item => {
      const val = item[field] || '';
      return val === displayName;
    });
  },

  async apiFetch(url, options = {}) {
    const token = this.getToken();
    const headers = {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
      ...(options.headers || {})
    };
    const res = await fetch(url, { ...options, headers });
    // 自动续期：后端返回新 token 时更新本地存储
    const fresh = res.headers.get('X-Refresh-Token');
    if (fresh) { try { sessionStorage.setItem('efast_token', fresh); if (localStorage.getItem('efast_token_persist')) localStorage.setItem('efast_token_persist', fresh); } catch (e) {} }
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || '请求失败');
    return data;
  }
};

window.Auth = Auth;
export { Auth };
